import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { lastValueFrom, of } from 'rxjs';
import { CommitteesService } from './committees.service';

@Injectable({
  providedIn: 'root'
})
export class CommitteeResolver  {
  public element_id: string | number | undefined;

  constructor(
    private committeesService: CommitteesService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    this.element_id = route.params.id;
    return this.element_id != 'new' ? this.committeesService.find(this.element_id) : lastValueFrom(of(null));
  }
}
